export const LOAD_THEMES_SETTINGS = 'LOAD_THEMES_SETTINGS';
export const UPDATE_THEMES_SETTINGS = 'UPDATE_THEMES_SETTINGS';
